import React, {Component} from 'react';
import * as LocalStorage from '../../../utils/localStorageHelper';
import * as GoogleMapApi from '../../../utils/googleApiHelper';

class UserAddresses extends Component {

  constructor(props) {
    super(props);
    this.state = {}

    this.addNewAddress = this.addNewAddress.bind(this);
    this.editAddress = this.editAddress.bind(this);
    this.deleteAddress = this.deleteAddress.bind(this);
  }

  getAddressLabel(address = {}) {
    const { label, title, nickname, name, type } = address;
    return label || title || nickname || name || type || 'Address';
  }

  formatAddressLines(address = {}) {
    const apartmentLine = address.apartment ? `Apartment #: ${address.apartment}` : null;
    const cityStateZip = [address.city, address.state, address.zip || address.postalCode]
      .filter(Boolean)
      .join(', ');

    return [
      address.description,
      apartmentLine,
      cityStateZip
    ].filter(Boolean);
  }

  render() {

    const {addresses} = this.props;
    return (
      <div className="address-book">
        <div className="address-book-header">
          <div>
            <h2>Saved Addresses</h2>
            <p>Manage where we deliver your orders.</p>
          </div>
        </div>

        <div className="address-book-body">
          {addresses && addresses.length ? (
            addresses.map(address => {
              const addressLines = this.formatAddressLines(address);
              return (
                <div
                  className="address-row"
                  key={address._id}
                  onClick={() => this.editAddress(address)}
                >
                  <div className="address-row-text">
                    <div className="address-label">{this.getAddressLabel(address)}</div>
                    <div className="address-lines">
                      {addressLines.map((line, idx) => (
                        <div className="address-line" key={`${address._id}_line_${idx}`}>{line}</div>
                      ))}
                    </div>
                  </div>
                  <div className="address-actions">
                    <button
                      className="icon-button danger"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.deleteAddress(address);
                      }}
                      aria-label="Delete address"
                    >
                      <i className="fa fa-trash-o" />
                    </button>
                  </div>
                </div>
              )
            })
          ) : (
            <div className="address-empty">No saved addresses yet.</div>
          )}

          <button className="address-add-card" onClick={() => this.addNewAddress()}>
            <span className="add-icon"><i className="fa fa-plus-circle" /></span>
            <span className="add-copy">
              <span className="add-title">Add New Address</span>
              <span className="add-subtitle">Save another location for quick checkout</span>
            </span>
          </button>
        </div>
      </div>
    )
  }

  addNewAddress() {
    this.props.history.push({pathname:'/place-picker', state: {actionMode: 'add'}});
  }

  editAddress(address) {

    let loc = address.loc;
    console.log(address);
    if(address.loc && address.loc[0] && address.loc[1]) {
      GoogleMapApi.getPlaceByLatLng(address.loc[1], address.loc[0]).then(place => {
        console.log("PLACE_GET_BY_LAT_LNG", place);
        LocalStorage.put("edit_google_place", place);
        this.props.history.push({pathname:'/place-picker', state: {actionMode: 'edit', addressId: address._id,apartment:address.apartment}});
      }).catch(error => alert(error));
    } else {
      alert('Something went wrong!')
    }

  }

  deleteAddress(address) {

    const {onDeleteAddress} = this.props;
    if(onDeleteAddress) onDeleteAddress(address);
  }

}

export default UserAddresses;



// WEBPACK FOOTER //
// ./src/containers/settings/profile/Addresses.js